/** 执行结果表格头配置 */
module.exports = () => {
  return [
    { name: '渠道包名称', value: 'channel_name', align: 'center', overflow: false },
    { name: '渠道包标识', value: 'channel_id', align: 'center', overflow: false },
    { name: '渠道包ID', value: 'channel_package_id', align: 'center', overflow: false },
    { name: '所属账号主', value: 'advertiser_id', align: 'center', overflow: false },
    { name: '所属广告包ID', value: 'package_id', align: 'center', overflow: false },
    { name: '操作结果描述', value: 'message', align: 'center', overflow: false },
  ];
};
